"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeSnowplowTrackerReadyEventListener = exports.dispatchSnowplowTrackerReadyEvent = exports.dispatchSnowplowTrackerNotReadyEvent = exports.addSnowplowTrackerReadyEventListener = exports.isReady = exports.SNOWPLOW_TRACKER_NAME = exports.pageAttributesContext = exports.brandAttributesContext = exports.snowplowTracker = exports.enhancedPageView = void 0;
var utils_1 = require("./src/utils");
Object.defineProperty(exports, "addSnowplowTrackerReadyEventListener", {
  enumerable: true,
  get: function get() {
    return utils_1.addSnowplowTrackerReadyEventListener;
  }
});
Object.defineProperty(exports, "dispatchSnowplowTrackerNotReadyEvent", {
  enumerable: true,
  get: function get() {
    return utils_1.dispatchSnowplowTrackerNotReadyEvent;
  }
});
Object.defineProperty(exports, "dispatchSnowplowTrackerReadyEvent", {
  enumerable: true,
  get: function get() {
    return utils_1.dispatchSnowplowTrackerReadyEvent;
  }
});
Object.defineProperty(exports, "removeSnowplowTrackerReadyEventListener", {
  enumerable: true,
  get: function get() {
    return utils_1.removeSnowplowTrackerReadyEventListener;
  }
});
Object.defineProperty(exports, "enhancedPageView", {
  enumerable: true,
  get: function get() {
    return utils_1.enhancedPageView;
  }
});
Object.defineProperty(exports, "isReady", {
  enumerable: true,
  get: function get() {
    return utils_1.isReady;
  }
});
var tracker_1 = __importDefault(require("./src/tracker"));
exports.snowplowTracker = tracker_1["default"];
var entities_1 = require("./src/dataStructures/entities");
Object.defineProperty(exports, "brandAttributesContext", {
  enumerable: true,
  get: function get() {
    return entities_1.brandAttributesContext;
  }
});
Object.defineProperty(exports, "pageAttributesContext", {
  enumerable: true,
  get: function get() {
    return entities_1.pageAttributesContext;
  }
});
var constants_1 = require("./src/tracker/constants");
Object.defineProperty(exports, "SNOWPLOW_TRACKER_NAME", {
  enumerable: true,
  get: function get() {
    return constants_1.SNOWPLOW_TRACKER_NAME;
  }
});